import api from "../../../api/api";

const getCheckinQueueList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/counter/appointment/queue-list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :"res.data.msg"
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}


const getAppointmentPendingList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/counter/appointment/pending-list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :"res.data.msg"
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const callAppointmentVisitor = () =>{
    return new Promise((resolve, reject)=>{
        api.get("counter/appointment/call-visitor").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const callOnHoldVisitor = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("counter/appointment/call-onhold-visitor",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const updateAppointmentStatus = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("counter/appointment/update-status",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const transferToken = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("counter/appointment/transfer-token",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}


const addRemark = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("counter/appointment/add-remark",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const getRemarkList = (uid) =>{
    return new Promise((resolve, reject)=>{
        api.get("counter/appointment/remark/"+uid).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}





const counterAppointmentServices = {
    getCheckinQueueList,
    getAppointmentPendingList,
    callAppointmentVisitor,
    updateAppointmentStatus,
    callOnHoldVisitor,
    transferToken,
    addRemark,
    getRemarkList   
}
export default counterAppointmentServices;
